import { render, staticRenderFns } from "./ruleView.vue?vue&type=template&id=6eb6dad3&scoped=true"
import script from "./ruleView.vue?vue&type=script&lang=js"
export * from "./ruleView.vue?vue&type=script&lang=js"
import style0 from "./ruleView.vue?vue&type=style&index=0&id=6eb6dad3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6dad3",
  null
  
)

export default component.exports